'use strict';
(function () {
  if (customElements.get('highest-selling-slider')) return;

  function waitForSwiper() {
    if (typeof Swiper !== 'undefined') {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      const swiperScript = document.getElementById('swiper-bundle-js');

      const finish = () => {
        if (typeof Swiper !== 'undefined') resolve();
      };

      if (swiperScript) {
        swiperScript.addEventListener('load', finish, { once: true });
      }

      const poll = window.setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          window.clearInterval(poll);
          resolve();
        }
      }, 50);

      window.setTimeout(() => {
        window.clearInterval(poll);
        finish();
      }, 10000);
    });
  }

  class HighestSellingSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.slider = this.querySelector('.swiper');
      this.pagination = this.querySelector('.highest-selling__pagination');
      this.nextBtn = this.querySelector('.highest-selling__slider-arrow--next');
      this.prevBtn = this.querySelector('.highest-selling__slider-arrow--prev');

      const { loop, autoplay } = this.dataset;

      this.swiperParams = {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        loop: loop === 'true',
        autoplay: autoplay === 'true' ? { delay: 3500, disableOnInteraction: false } : false,
        grabCursor: true,
        pagination: this.pagination
          ? {
              el: this.pagination,
              clickable: true,
            }
          : false,
        on: {
          slideChange: () => this.updateNavigationButtons(),
          init: () => this.updateNavigationButtons(),
        },
      };

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          if (this.swiper) this.swiper.slideNext();
        });
      }
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          if (this.swiper) this.swiper.slidePrev();
        });
      }
    }

    connectedCallback() {
      if (this.slider) {
        waitForSwiper().then(() => {
          if (this.isConnected) this.initSwiper();
        });
      }
    }

    initSwiper() {
      this.swiper = new Swiper(this.slider, this.swiperParams);
      this.updateNavigationButtons();
      this.watchImagesForHeight();
    }

    watchImagesForHeight() {
      // autoHeight measures synchronously on init/slideChange, which can run
      // before a lazy-loaded image has finished loading and clip it out.
      // Re-measure once each image is actually loaded.
      this.querySelectorAll('.highest-selling__card-image img').forEach((img) => {
        if (img.complete) {
          this.refreshHeight();
        } else {
          img.addEventListener('load', () => this.refreshHeight(), { once: true });
        }
      });
    }

    refreshHeight() {
      if (this.swiper) this.swiper.updateAutoHeight(0);
    }

    updateNavigationButtons() {
      if (!this.swiper || !this.nextBtn || !this.prevBtn) return;

      if (this.swiper.isLocked) {
        this.prevBtn.classList.add('disabled');
        this.nextBtn.classList.add('disabled');
      } else if (this.swiper.isBeginning) {
        this.prevBtn.classList.add('disabled');
        this.nextBtn.classList.remove('disabled');
      } else if (this.swiper.isEnd) {
        this.nextBtn.classList.add('disabled');
        this.prevBtn.classList.remove('disabled');
      } else {
        this.prevBtn.classList.remove('disabled');
        this.nextBtn.classList.remove('disabled');
      }
    }
  }

  customElements.define('highest-selling-slider', HighestSellingSlider);
})();
